import React from "react";

export const SectionHeading = ({ overline, title, subtitle, center, light }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-12`}>
    {overline && (
      <span className={`text-xs tracking-[0.2em] uppercase font-bold ${light ? "text-brand-accent" : "text-brand-green"}`}>
        {overline}
      </span>
    )}
    <h2 className={`mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-blue-100" : "text-slate-600"}`}>{subtitle}</p>
    )}
  </div>
);

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative bg-brand-blue overflow-hidden">
    {image && (
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
    )}
    <div className="absolute inset-0 bg-gradient-to-r from-brand-blue via-brand-blue/95 to-brand-blue/70" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
      {overline && (
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-brand-accent">{overline}</span>
      )}
      <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-white max-w-3xl">{title}</h1>
      {subtitle && <p className="mt-5 text-lg text-blue-100 max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
